import { router, usePage } from '@inertiajs/react';
import CalendarTodayRoundedIcon from '@mui/icons-material/CalendarTodayRounded';
import Button from '@mui/material/Button';
import { useForkRef } from '@mui/material/utils';
import {
  useParsedFormat,
  usePickerContext,
  useSplitFieldProps,
} from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import * as React from 'react';

dayjs.extend(timezone);
dayjs.extend(utc);
dayjs.locale('pt-br');

function ButtonField(props) {
  const { forwardedProps } = useSplitFieldProps(props, 'date');
  const pickerContext = usePickerContext();
  const handleRef = useForkRef(pickerContext.triggerRef, pickerContext.rootRef);
  const parsedFormat = useParsedFormat();
  const valueStr =
    pickerContext.value == null
      ? parsedFormat
      : pickerContext.value.format(pickerContext.fieldFormat);

  return (
    <Button
      {...forwardedProps}
      variant="outlined"
      ref={handleRef}
      size="small"
      startIcon={<CalendarTodayRoundedIcon fontSize="small" />}
      sx={{ minWidth: 'fit-content' }}
      onClick={() => pickerContext.setOpen((prev) => !prev)}
    >
      {pickerContext.label ?? valueStr}
    </Button>
  );
}

export default function TowerDatePicker() {
  const { props } = usePage();
  const selectedDate = props.selected_date ? dayjs(props.selected_date) : dayjs(new Date());
  const [value, setValue] = React.useState(dayjs(selectedDate));
  const [loading, setLoading] = React.useState(false);

  const handleChange = (newValue) => {
    setLoading(true);
    setValue(newValue);
    router.get(
      '/towers',
      { date: newValue.format('YYYY-MM-DD') },
      {
        preserveScroll: true,
        preserveState: true,
        replace: true,
      }
    );
    setLoading(false);
  };

  const getLabel = (value) => {
    if (value == null) return null;
    if (value.isSame(dayjs(), 'day')) return 'Hoje';
    if (value.isSame(dayjs().subtract(1, 'day'), 'day')) return 'Ontem';

    return value.format('DD/MM/YYYY');
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        utc={true}
        timezone='America/Sao_Paulo'
        loading={loading}
        disableFuture
        adapterLocale="pt-br"
        value={value}
        label={getLabel(value)}
        onChange={(newValue) => handleChange(newValue)}
        slots={{ field: ButtonField }}
        slotProps={{
          nextIconButton: { size: 'small' },
          previousIconButton: { size: 'small' },
          calendarHeader: {
            sx: {
              '.MuiPickersCalendarHeader-label': {
                textTransform: 'capitalize',
              },
            },
          },
        }}
        views={['day']}
      />
    </LocalizationProvider>
  );
}
